import { render } from "./Draft.vue?vue&type=template&id=feeb66a8"
import script from "./Draft.vue?vue&type=script&lang=js"
export * from "./Draft.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__